'use client'

import { setTag, setUser } from '@sentry/browser'
import { useEffect } from 'react'
import { useUser } from '@/hooks/use-user'
import { useWorkspaceId } from '@/hooks/use-workspace'

/**
 * Identifies the current user and workspace in Sentry so errors/traces/logs
 * are tagged with user + workspace info for filtering and debugging.
 */
export function SentryUserIdentity() {
  const { data: user } = useUser()
  const workspaceId = useWorkspaceId()

  useEffect(() => {
    if (user) {
      setUser({
        id: user.id,
        email: user.email ?? undefined,
        username: user.full_name ?? user.email ?? undefined,
      })
    } else {
      setUser(null)
    }
  }, [user])

  useEffect(() => {
    if (workspaceId) {
      setTag('workspace_id', workspaceId)
    }
  }, [workspaceId])

  return null
}
